import React from 'react';
import shared from '../../shared';
import Banner, { BANNER_TYPE_WARNING } from '../Banner';
import { DCP_DEV_LINK, DCP_PREPROD_LINK, DCP_PROD_LINK } from '../../constants';

// Maps environment -> partition -> DCP Console domain.
// TODO: add staging entry once DCP Console supports the Perf environment.
const DCP_CONSOLE_DOMAINS = {
  dev: { default: DCP_DEV_LINK },
  prod: {
    sb1: DCP_PREPROD_LINK,
    na: DCP_PROD_LINK,
    // CNP is intentionally omitted — DCP Console doesn't support it, so no link is shown.
  },
};
const COMMAND_LIST_PATH = '/services/command-management-service/definitions/list';

const getDcpConsoleDomain = (environment, partition) => {
  const envDomains = DCP_CONSOLE_DOMAINS[environment];
  if (!envDomains) return null;
  return envDomains[partition] ?? envDomains.default ?? null;
};

const getBannerValues = (domain) => {
  if (!domain) return { a: (text) => text };

  return {
    a: (text) => (
      <a href={`${domain}${COMMAND_LIST_PATH}`} target='_blank' rel='noopener noreferrer'>
        {text}
      </a>
    ),
  };
};

const CommandDeprecationBanner = ({ className }) => {
  const domain = getDcpConsoleDomain(shared.config.environment, shared.config.partition);
  const values = getBannerValues(domain);

  return <Banner type={BANNER_TYPE_WARNING} displayId='au.command.bannerText' values={values} className={className} />;
};

export default CommandDeprecationBanner;
